import routes from "../constants/routes";
import { lazyLoadRoutes } from "../utils/lazy-loader";

export const assetsRoutes = [
  {
    path: routes.assets.AssetGroup,
    element: lazyLoadRoutes("assets/pages/AssetGroup"),
  },

  {
    path: routes.assets.AssetList,
    element: lazyLoadRoutes("assets/pages/AssetList"),
  },

  {
    path: routes.assets.requisitionList,
    element: lazyLoadRoutes("assets/pages/requisitionList"),
  },

  {
    path: routes.assets.inStoreAssetsList,
    element: lazyLoadRoutes("assets/pages/InStoreAssets"),
  },

  {
    path: routes.assets.requestList,
    element: lazyLoadRoutes("assets/pages/requestList"),
  },

  {
    path: routes.assets.issueList,
    element: lazyLoadRoutes("assets/pages/IssueList"),
  },
  {
    path: routes.assets.uploadDocuments,
    element: lazyLoadRoutes("assets/pages/uploadDocuments"),
  },
  {
    path: `${routes.assets.assetsIssuedList}/:id`,
    element: lazyLoadRoutes("assets/pages/assetsIssuedList"),
  },
];
